import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as headings from './Headings';
import { Code } from './Code';
import { Layout } from './Layout';
import { Playground } from './Playground';
import { Pre } from './Pre';
import { Props } from './Props';
export default _objectSpread({}, headings, {
  code: Code,
  playground: Playground,
  pre: Pre,
  layout: Layout,
  props: Props
});

if (typeof props !== 'undefined' && props && props === Object(props) && Object.isExtensible(props) && !props.hasOwnProperty('__filemeta')) {
  Object.defineProperty(props, '__filemeta', {
    configurable: true,
    value: {
      name: "props",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}

if (typeof layout !== 'undefined' && layout && layout === Object(layout) && Object.isExtensible(layout) && !layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(layout, '__filemeta', {
    configurable: true,
    value: {
      name: "layout",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}

if (typeof pre !== 'undefined' && pre && pre === Object(pre) && Object.isExtensible(pre) && !pre.hasOwnProperty('__filemeta')) {
  Object.defineProperty(pre, '__filemeta', {
    configurable: true,
    value: {
      name: "pre",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}

if (typeof playground !== 'undefined' && playground && playground === Object(playground) && Object.isExtensible(playground) && !playground.hasOwnProperty('__filemeta')) {
  Object.defineProperty(playground, '__filemeta', {
    configurable: true,
    value: {
      name: "playground",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}

if (typeof code !== 'undefined' && code && code === Object(code) && Object.isExtensible(code) && !code.hasOwnProperty('__filemeta')) {
  Object.defineProperty(code, '__filemeta', {
    configurable: true,
    value: {
      name: "code",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}